import { useSearchParams } from 'react-router-dom'

const useTabsSearchParam = ({ tabs, defaultTab }) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const tabValues = tabs.map(tab => tab.value)
  const tabFromUrl = searchParams.get('tab')
  const activeTab = tabValues.includes(tabFromUrl) ? tabFromUrl : defaultTab

  const onChangeTab = tab => {
    setSearchParams({ tab }, { replace: true })
  }

  return { activeTab, onChangeTab }
}

export default useTabsSearchParam
